import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, getUserRole } from './auth';

const PublicRoute = ({ children }) => {
    const isAuth = isAuthenticated();
    const userRole = getUserRole();

    if (isAuth) {
        const redirectPath =
            userRole === 'corporate' ? '/corporate/dashboard' :
            userRole === 'admin' ? '/admin/dashboard' :
                userRole === 'professional' ? '/professional/services' :
                userRole === 'employee' ? '/employee/chat' :
                    userRole === 'user' ? '/user/chat' : '/';

        return <Navigate to={redirectPath} />;
    }

    return children;
};



export default PublicRoute;
